package com.appcreator.compose.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.appcreator.blueprint.components.ReferenceComponent
import com.appcreator.blueprint.core.properties.ComponentProperty
import com.appcreator.blueprint.core.properties.ComponentResult
import com.appcreator.compose.LocalEnvStore
import com.appcreator.compose.loaders.ComponentFetcher
import kotlinx.serialization.json.jsonPrimitive

@Composable
expect fun ReferenceComposable(componentFetcher: ComponentFetcher, modifier: Modifier, component: ReferenceComponent)

@Composable
fun ReferenceComposableInternal(componentFetcher: ComponentFetcher, modifier: Modifier, component: ReferenceComponent) {
    component.content?.let { content ->
        val result: ComponentResult? = content.injected?: remember(content.id) { componentFetcher.loadComponent(content.id) }.value
        result?.let { (properties, actual) ->
            val envStore = LocalEnvStore.current
            val new = remember(component) {
                properties.mapNotNull { property ->
                    runCatching {
                        val value = component.content?.propertyValues?.get(property.name)
                        value?.let { value ->
                            property.name to when (property.type) {
                                ComponentProperty.PropertyType.Text -> envStore.injectVariables(value.jsonPrimitive.content)
                                ComponentProperty.PropertyType.Component -> component.children!!.first { it._nodeId == value.jsonPrimitive.content }
                            }
                        }
                    }.getOrNull()
                }.toMap()
            }
            EnvComposable(properties = new) {
                ComponentComposable(modifier, actual)
            }
        }
    }
}